import { apiService, fetchingAPI } from '@/api'
import { toast } from '@/components/toasts/toast.helpers'
import { getScoreRange } from '@/utils/helpers'

import * as redux from './media.redux'

export const fetchVideoForCallId = async (callId, dispatch) => {
  try {
    const {
      video_addresses: videoUrls,
      video_file_status: videoStatus,
      expiration_seconds: videoUrlExpiration, // not used yet
    } = await fetchingAPI(
      `${apiService.reporting}/api/calls/${callId}/screen_capture`,
      'GET',
      dispatch
    )

    return { videoUrls, videoStatus, videoUrlExpiration }
  } catch {
    toast.error('Error fetching video')
    return null
  }
}

export const fetchAudioForCallId = async (callId, dispatch) => {
  try {
    const {
      audio_address: audioUrl,
      audio_file_status: audioStatus,
      expiration_seconds: audioUrlExpiration,
    } = await fetchingAPI(`${apiService.reporting}/api/calls/${callId}/audio`, 'GET', dispatch)

    return { audioUrl, audioStatus, audioUrlExpiration }
  } catch {
    toast.error('Error fetching audio')
    return null
  }
}

export const fetchMediaForCallId = (
  callId,
  shouldFetchAudio = true,
  shouldFetchVideo = true,
  isPlaying = true
) => {
  return async (dispatch) => {
    dispatch(redux.resetMediaPlayer())
    dispatch(redux.setLoading({ mediaPlayerByCallId: callId }))

    const fetchPromises = []

    if (shouldFetchAudio) {
      fetchPromises.push(fetchAudioForCallId(callId, dispatch))
    }
    if (shouldFetchVideo) {
      fetchPromises.push(fetchVideoForCallId(callId, dispatch))
    }

    try {
      const [audioResponse, videoResponse] = await Promise.all(fetchPromises)

      if (audioResponse) {
        const hasAudio = audioResponse.audioStatus === 'available'
        dispatch(
          redux.updateMediaPlayer({
            ...audioResponse,
            callId,
            isPlaying: hasAudio ? isPlaying : false,
          })
        )
      } else if (shouldFetchAudio) {
        dispatch(redux.updateMediaPlayer({ callId, audioError: true }))
      }

      if (videoResponse) {
        dispatch(redux.updateMediaPlayer({ ...videoResponse, callId }))
      } else if (shouldFetchVideo) {
        dispatch(redux.updateMediaPlayer({ callId, videoError: true }))
      }
    } catch (error) {
      // Error toasts handled individually
      console.error(error)
    } finally {
      dispatch(redux.setLoading({ mediaPlayerByCallId: null }))
    }
  }
}

export const setHardSelectedEvent = (newEvent) => (dispatch, getState) => {
  const { hardSelectedEvent } = getState().media.mediaPlayer
  // If we are trying to select an already select event, clear it instead
  const timestampsEqual = hardSelectedEvent?.timestamp === newEvent.timestamp
  const idsEqual = hardSelectedEvent?.id === newEvent.id

  if (timestampsEqual && idsEqual) {
    dispatch(redux.updateMediaPlayer({ hardSelectedEvent: null }))
  } else {
    dispatch(redux.updateMediaPlayer({ hardSelectedEvent: newEvent }))
  }
}

export const fetchSentimentForCallId = (callId, organizationId) => {
  return async (dispatch) => {
    dispatch(redux.setLoading({ sentiment: true }))

    try {
      const response = await fetchingAPI(
        `${apiService.reporting}/api/sentiment/call_id/${callId}?requested_organization_id=${organizationId}`,
        'GET',
        dispatch
      )
      const range = getScoreRange(response)
      dispatch(redux.setSentiment({ data: response, range }))
    } catch (err) {
      console.warn('Failed to fetch sentiment for call', err)
    } finally {
      dispatch(redux.setLoading({ sentiment: false }))
    }
  }
}
